// MAROVAR — scripts de marca (vanilla, sin librerias)

function mvInitReveals() {
  var els = document.querySelectorAll('.mv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function mvInitContadores() {
  var els = document.querySelectorAll('[data-mv-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-mv-contador'));
      var decimales = el.getAttribute('data-mv-decimales') === '1' ? 1 : 0;
      var duracion = 1600;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var ease = 1 - Math.pow(1 - progreso, 3);
        el.textContent = (fin * ease).toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

// Carrusel de opiniones: pista con scroll nativo (se desliza con el dedo en
// móvil y con las flechas en escritorio). La barra indica la posición.
function mvInitResenasCarrusel() {
  var wraps = document.querySelectorAll('[data-mv-resenas]');
  wraps.forEach(function (wrap) {
    var pista = wrap.querySelector('[data-mv-pista]');
    if (!pista) return;
    var tarjetas = pista.querySelectorAll('[data-mv-tarjeta]');
    if (!tarjetas.length) return;

    var prev = wrap.querySelector('[data-mv-prev]');
    var next = wrap.querySelector('[data-mv-next]');
    var progreso = wrap.querySelector('[data-mv-progreso]');

    function paso() {
      var t = tarjetas[0];
      var estilo = window.getComputedStyle(pista);
      var hueco = parseFloat(estilo.columnGap || estilo.gap || '20') || 20;
      return t.getBoundingClientRect().width + hueco;
    }

    function maximo() {
      return Math.max(pista.scrollWidth - pista.clientWidth, 0);
    }

    function actualizar() {
      var max = maximo();
      var x = pista.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (progreso) {
        var visible = Math.min(pista.clientWidth / pista.scrollWidth, 1);
        var ancho = Math.max(visible * 100, 8);
        var izq = max > 0 ? (x / max) * (100 - ancho) : 0;
        progreso.style.width = ancho + '%';
        progreso.style.left = izq + '%';
      }
    }

    function mover(direccion) {
      // Avanzar de tarjeta en tarjeta, o de bloque visible si caben varias
      var visibles = Math.max(Math.floor(pista.clientWidth / paso()), 1);
      pista.scrollBy({ left: direccion * paso() * visibles, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { mover(-1); });
    if (next) next.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();

    // Arrastrar con el ratón en escritorio
    var arrastrando = false, inicioX = 0, inicioScroll = 0;
    pista.addEventListener('mousedown', function (e) {
      arrastrando = true; inicioX = e.pageX; inicioScroll = pista.scrollLeft;
      pista.style.cursor = 'grabbing';
    });
    window.addEventListener('mouseup', function () {
      arrastrando = false; pista.style.cursor = '';
    });
    pista.addEventListener('mousemove', function (e) {
      if (!arrastrando) return;
      e.preventDefault();
      pista.scrollLeft = inicioScroll - (e.pageX - inicioX);
    });
  });
}

function mvInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mv-galeria-producto]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mv-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-mv-mini]');
    if (!principal) return;

    // El marco copia la proporcion de la foto que hay cargada. Asi ninguna sale
    // recortada (la galeria mezcla cuadradas, apaisadas y verticales) y tampoco
    // aparecen franjas de fondo alrededor.
    var marco = principal.parentElement;
    function ajustarMarco() {
      if (!marco || !principal.naturalWidth || !principal.naturalHeight) return;
      marco.style.aspectRatio = principal.naturalWidth + ' / ' + principal.naturalHeight;
    }
    if (principal.complete) ajustarMarco();
    principal.addEventListener('load', ajustarMarco);

    if (!minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!src) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          principal.alt = alt;
          principal.style.opacity = '1';
        }, 180);
        minis.forEach(function (m) { m.classList.remove('mv-activo'); });
        mini.classList.add('mv-activo');
      });
    });
  });
}

function mvInitVariantes() {
  var forms = document.querySelectorAll('[data-mv-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mv-variantes-json]');
    var selects = form.querySelectorAll('[data-mv-opcion]');
    if (!dataEl || !selects.length) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function variantesActuales() {
      var valores = [];
      selects.forEach(function (s) { valores.push(s.value); });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      var variante = variantesActuales();
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-mv-precio]');
      var compareEl = form.querySelector('[data-mv-precio-comparado]');
      var boton = form.querySelector('[data-mv-boton-comprar]');
      if (!variante) {
        if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-texto-agotado') || 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variante.id;
      // Al elegir un color, la foto principal pasa a ese color.
      if (variante.imagen) {
        var seccion = form.closest('.mv-producto');
        var principal = seccion && seccion.querySelector('[data-mv-imagen-principal]');
        if (principal) {
          var base = variante.imagen.split('?')[0];
          principal.src = variante.imagen;
          seccion.querySelectorAll('[data-mv-mini]').forEach(function (m) {
            var coincide = (m.getAttribute('data-full') || '').split('?')[0] === base;
            m.classList.toggle('mv-activo', coincide);
          });
        }
      }
      if (precioEl) precioEl.textContent = mvFormatoDinero(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = mvFormatoDinero(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (boton) {
        if (variante.available) {
          boton.disabled = false;
          boton.textContent = boton.getAttribute('data-texto-comprar') || boton.textContent;
        } else {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function mvFormatoDinero(centavos) {
  var valor = (centavos / 100).toFixed(2).replace('.', ',');
  return valor + ' €';
}

// El cajón del menú móvil de Dawn no se cierra solo al pulsar un enlace.
// Lo cerramos nosotros: en enlaces de ancla (#) y también al navegar,
// para que no quede abierto al volver atrás.
function mvInitCierreMenu() {
  var contenedor = document.querySelector('#Details-menu-drawer-container');
  if (!contenedor) return;

  var velo = null;

  function quitarVelo() {
    if (!velo) return;
    var v = velo;
    velo = null;
    v.classList.remove('mv-velo--visible');
    setTimeout(function () {
      if (v && v.parentNode) v.parentNode.removeChild(v);
    }, 380);
  }

  function ponerVelo() {
    if (velo || window.innerWidth >= 990) return;
    velo = document.createElement('div');
    velo.className = 'mv-velo';
    velo.setAttribute('aria-hidden', 'true');
    velo.addEventListener('click', cerrar);
    document.body.appendChild(velo);
    // Forzar un reflow para que la transición de opacidad se vea
    void velo.offsetWidth;
    velo.classList.add('mv-velo--visible');
  }

  function cerrar() {
    if (!contenedor.hasAttribute('open')) {
      quitarVelo();
      return;
    }
    var componente = document.querySelector('header-drawer');
    // Ruta preferida: el propio componente de Dawn (restaura el scroll del body)
    if (componente && typeof componente.close === 'function') {
      componente.close();
    } else {
      contenedor.removeAttribute('open');
      var resumen = contenedor.querySelector('summary');
      if (resumen) resumen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
    }
    quitarVelo();
  }

  // Sincronizar el velo con el estado real del cajón
  var observador = new MutationObserver(function () {
    if (contenedor.hasAttribute('open')) ponerVelo();
    else quitarVelo();
  });
  observador.observe(contenedor, { attributes: true, attributeFilter: ['open'] });

  // Cerrar al pulsar cualquier enlace del menú
  contenedor.addEventListener('click', function (evento) {
    if (evento.target.closest('a[href]')) setTimeout(cerrar, 80);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) quitarVelo();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mvInitCierreMenu();
  mvInitReveals();
  mvInitContadores();
  mvInitResenasCarrusel();
  mvInitGaleriaProducto();
  mvInitVariantes();
});
